import LegalCompliance from './ModuleLegalCompliance';
import GlobalLegalCompliance from './ModuleGlobalLegalCompliance';
import CorrectiveActions from './ModuleCorrectiveActions';
import UserManagement from './ModuleUserManagement';
import CommunicationPipeline from './ModuleCommunicationPipeline';
import { routes as Intelligence } from './ModuleIntelligence';
import { routes as SaicaReports } from './ModuleSaicaReports';
import { routes as ComsaReports } from './ModuleComsaReports';
import ComsaEnvironmental from './ModuleComsaEnvironmental';
import { routes as QseReports } from './ModuleQseReports';
import { routes as ChemicalTrading } from './ModuleChemicalTrading';
import { routes as NewsletterManager } from './ModuleNewsletterManager';
import { routes as lawFinder } from './ModuleLawFinder';
import { routes as ModuleBridgeFolder } from './ModuleModuleBridgeFolder';
import ModuleResourceManager from './ModuleResourceManager';
import ModuleInecoRiskManager from './ModuleInecoRiskManager';
import ModuleDocumentManager from './ModuleDocumentManager';
import ModuleTotalEnergiesRisk from './ModuleTotalEnergiesRisk';
import ModuleEnvironmentalAspectsAssessment from './ModuleEnvironmentalAspectsAssessment';

export default {
  ...LegalCompliance,
  ...GlobalLegalCompliance,
  ...CorrectiveActions,
  ...UserManagement,
  ...CommunicationPipeline,
  ...Intelligence,
  ...ModuleBridgeFolder,
  ...SaicaReports,
  ...ComsaReports,
  ...ComsaEnvironmental,
  ...QseReports,
  ...ChemicalTrading,
  ...NewsletterManager,
  ...lawFinder,
  ...ModuleResourceManager,
  ...ModuleInecoRiskManager,
  ...ModuleDocumentManager,
  ...ModuleTotalEnergiesRisk,
  ...ModuleEnvironmentalAspectsAssessment,

  user_home: {
    path: '',
  },
  user_login: {
    path: 'login/',
  },
  user_2fa_challenge: {
    path: 'o/2fa/:method/:challenge/',
    parameters: {
      method: undefined,
      challenge: undefined,
    },
  },
  user_change_password: {
    path: 'change-password/',
  },
  user_remember_password: {
    path: 'o/remember-password/',
  },
  user_remember_password_set: {
    path: 'o/remember-password/set/:rememberPasswordHex/',
    parameters: {
      rememberPasswordHex: undefined,
    },
  },
  user_double_auth: {
    path: 'o/double-auth',
  },
  user_access_code_login: {
    path: 'o/user-access-code/:client/login/',
    parameters: {
      client: undefined,
    },
  },
  user_auth_client: {
    path: 'o/auth/:client/',
    parameters: {
      client: undefined,
    },
  },
  user_sso: {
    path: 'o/sso/:client/',
    parameters: {
      client: undefined,
    },
  },
  user_impersonate: {
    path: 'o/imp/:challenge/',
    parameters: {
      challenge: undefined,
    },
  },
};
